const WebFont = require('webfontloader');

WebFont.load({
  google: {
    families: [
        'Poppins:400,700',
        'Roboto Condensed:400,700',
    ],
  },
});



// WEBPACK FOOTER //
// ./scripts/google-fonts.js